import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setUserInfo } from '@redux/user';
import cookies from 'browser-cookies';

@withRouter
class AuthRoute extends React.Component {
  componentDidMount() {
      const {pathname} = this.props.location;
      // 弱密码修改页无需登录即可访问
      if (pathname === '/resetPwd') {
          return;
      }
      if (cookies.get('termite-sys-token')) {
          return;
      }
      this.props.history.push('/login');
  }
  render() {
    return null;
  }
}

export default AuthRoute;
